import { XCircleIcon } from '@heroicons/react/24/outline';

const CVItem = ({ number, key, onRemove = () => {} }) => {
  return (
    <div
      className="bg-blue-900 inline-flex items-center text-white rounded-md px-1 pr-2 hover:bg-blue-700 hover:transition-all hover:duration-300 mx-0.5"
      key={key}
    >
      <XCircleIcon
        onClick={onRemove}
        className="inline-block w-4 h-4 hover:text-blue-300 mr-1"
      />
      {number}
    </div>
  );
};

export default CVItem;
